import React from 'react';
import Img from 'gatsby-image'
import styles from './BannerImage.module.scss';

const BannerImage = (props) => (
  <div className={styles.BannerImage} id={props.identifier}>
    {
        props.image &&
        <div>
            <Img sizes={props.image.sizes} alt={props.image.title} />
            <p>{props.image.title}</p>
        </div>
    }
    {
        props.src &&
        <img src={ props.src } alt="" />
    }
  </div>
)

export default BannerImage;



// WEBPACK FOOTER //
// ./src/components/Destination/BannerImage/index.js